// Gift with purchase: keeps exactly one gift line (property _gwp) in the cart
// while the rewards total is at or above the threshold, and removes it when the
// total drops below the threshold or GWP is disabled in theme settings.
// The rewards total skips the gift and the shipping liner (shipping protection
// counts), matching snippets/cart-rewards-total.liquid.
(function () {
  var config = window.cartGwpConfig || {};
  var GWP_PROPERTY = '_gwp';
  var INTERNAL_HEADER = 'X-Cart-Gwp';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var MAX_PASSES = 4;

  var giftVariantId = Number(config.variantId) || null;
  var threshold = Number(config.threshold) || 0;
  var enabled = !!config.enabled && !!giftVariantId && threshold > 0;

  // Nothing to add and nothing to clean up.
  if (!enabled && !config.giftInCart) return;

  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
  var publishFn = typeof publish === 'function' ? publish : window.publish;
  var subscribeFn = typeof subscribe === 'function' ? subscribe : window.subscribe;

  var isRunning = false;
  var rerunRequested = false;
  var giftUnavailable = false;
  var scheduleTimer = null;

  window.__withCartLock =
    window.__withCartLock ||
    function (fn) {
      window.__cartOpsQueue = window.__cartOpsQueue || Promise.resolve();
      var run = function () {
        return Promise.resolve().then(fn);
      };
      var next = window.__cartOpsQueue.then(run, run);
      window.__cartOpsQueue = next.catch(function () {});
      return next;
    };

  function route(path) {
    return cartRoot + path.replace(/^\//, '');
  }

  function isGiftLine(item) {
    return !!(item && item.properties && item.properties[GWP_PROPERTY]);
  }

  function isExcludedLine(item) {
    if (isGiftLine(item)) return true;
    var variantId = Number(item.variant_id || item.id);
    var linerConfig = window.shippingLinerAutoAddConfig;
    var linerVariantId = linerConfig && Number(linerConfig.variantId);
    return !!linerVariantId && variantId === linerVariantId;
  }

  function getRewardsTotal(cart) {
    return cart.items.reduce(function (total, item) {
      return isExcludedLine(item) ? total : total + Number(item.final_line_price || 0);
    }, 0);
  }

  function request(path, body) {
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[INTERNAL_HEADER] = '1';
    return fetch(route(path), {
      method: body ? 'POST' : 'GET',
      headers: headers,
      credentials: 'same-origin',
      cache: 'no-store',
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var error = new Error((data && data.description) || 'Cart request failed (' + response.status + ')');
          error.status = response.status;
          throw error;
        }
        return data;
      });
    });
  }

  function addGift() {
    var properties = {};
    properties[GWP_PROPERTY] = '1';
    return request('cart/add.js', {
      items: [{ id: giftVariantId, quantity: 1, properties: properties }],
      sections: SECTIONS,
      sections_url: window.location.pathname,
    }).catch(function (error) {
      // Sold out or quantity limited: stop retrying on this page view.
      if (error.status === 422) giftUnavailable = true;
      throw error;
    });
  }

  function changeLine(key, quantity) {
    return request('cart/change.js', {
      id: key,
      quantity: quantity,
      sections: SECTIONS,
      sections_url: window.location.pathname,
    });
  }

  function getSectionInnerHTML(html, selector) {
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return source ? source.innerHTML : null;
  }

  function renderSections(state) {
    var sections = state && state.sections;
    if (!sections) return;

    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (drawerInner && sections['cart-drawer']) {
      var drawerHTML = getSectionInnerHTML(sections['cart-drawer'], '.drawer__inner');
      if (drawerHTML !== null) drawerInner.innerHTML = drawerHTML;
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var bubbleHTML = getSectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (bubbleHTML !== null) bubble.innerHTML = bubbleHTML;
    }
  }

  function notifyCartUpdate(state) {
    if (publishFn && pubSubEvents && pubSubEvents.cartUpdate) {
      publishFn(pubSubEvents.cartUpdate, { source: 'cart-gwp', cartData: state });
    }
  }

  // Returns the pending cart mutation, or null when the cart is already correct.
  function nextMutation(cart) {
    var giftLines = cart.items.filter(isGiftLine);
    var eligible = enabled && !giftUnavailable && getRewardsTotal(cart) >= threshold;

    if (!eligible) {
      return giftLines.length ? changeLine(giftLines[0].key, 0) : null;
    }

    var primaryLine = null;
    for (var i = 0; i < giftLines.length; i++) {
      if (Number(giftLines[i].variant_id) === giftVariantId) {
        primaryLine = giftLines[i];
        break;
      }
    }

    var staleLine = giftLines.filter(function (line) {
      return line !== primaryLine;
    })[0];
    if (staleLine) return changeLine(staleLine.key, 0);
    if (!primaryLine) return addGift();
    if (Number(primaryLine.quantity) !== 1) return changeLine(primaryLine.key, 1);
    return null;
  }

  function ensureGift(pass) {
    pass = pass || 1;
    if (isRunning) {
      rerunRequested = true;
      return;
    }
    isRunning = true;
    rerunRequested = false;

    var mutated = false;
    window
      .__withCartLock(function () {
        return request('cart.js').then(function (cart) {
          var mutation = nextMutation(cart);
          if (!mutation) return null;
          mutated = true;
          return mutation;
        });
      })
      .then(function (state) {
        if (!state) return;
        renderSections(state);
        notifyCartUpdate(state);
      })
      .catch(function (error) {
        if (window.console) console.warn('[cart-gwp]', error);
      })
      .finally(function () {
        isRunning = false;
        // One mutation per pass; re-check until the cart is settled.
        if (rerunRequested || (mutated && pass < MAX_PASSES)) {
          ensureGift(mutated ? pass + 1 : 1);
        }
      });
  }

  function schedule() {
    clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(function () {
      ensureGift(1);
    }, 150);
  }

  function hasInternalHeader(init) {
    var headers = init && init.headers;
    if (!headers) return false;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) return headers.get(INTERNAL_HEADER) === '1';
    if (Array.isArray(headers)) {
      return headers.some(function (entry) {
        return String(entry[0]).toLowerCase() === INTERNAL_HEADER.toLowerCase();
      });
    }
    return headers[INTERNAL_HEADER] === '1';
  }

  // Catches cart changes made by apps or scripts that do not publish cartUpdate.
  function installFetchListener() {
    if (!window.fetch || window.__cartGwpFetchPatched) return;
    window.__cartGwpFetchPatched = true;

    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var isCartMutation = false;
      try {
        isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?$/.test(new URL(url, window.location.origin).pathname);
      } catch (error) {
        isCartMutation = false;
      }
      var isInternal = hasInternalHeader(init);

      return originalFetch(input, init).then(function (response) {
        if (isCartMutation && !isInternal && response && response.ok) schedule();
        return response;
      });
    };
  }

  if (subscribeFn && pubSubEvents && pubSubEvents.cartUpdate) {
    subscribeFn(pubSubEvents.cartUpdate, function (event) {
      if (event && event.source === 'cart-gwp') return;
      schedule();
    });
  }

  installFetchListener();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
